import {
  AutoComplete,
  FormContainer,
  Treturn,
  useFetch,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { IClassificationProps } from "./models";
import {
  createClassification,
  getClassificationById,
  updateClassification,
} from "../../../../../../../services/listImportAutomationClassification.service";
import {
  classificationSchema,
  TClassificationForm,
} from "./classificationSchema";
import { listClassificationsByProfileAccess } from "../../../../../../../services/listProfileAccess.service";

const translationPath =
  "page.4uDlist.listImportAutomation.dlist_classifications.";

export const Classification = memo(
  ({ id, listImportAutomationId, onBackButton }: IClassificationProps) => {
    const { t } = useTranslation();

    const { sendRequest: save, loading: sLoading } =
      useFetch(createClassification);

    const { sendRequest: update, loading: uLoading } =
      useFetch(updateClassification);

    const { sendRequest: get, loading: gLoading } = useFetch(
      getClassificationById
    );

    const updateHandler = (v: TClassificationForm, id: string) =>
      update({
        item: {
          id: id,
          listImportAutomationId: listImportAutomationId ?? "",
          listClassificationId: v.listClassification.id,
        },
        id: id,
      });

    const saveHandler = (v: TClassificationForm) =>
      save({
        listImportAutomationId: listImportAutomationId ?? "",
        listClassificationId: v.listClassification.id,
      });

    const getHandler = useCallback(
      async (id: string): Promise<Treturn<TClassificationForm>> => {
        const { data, success } = await get(id);

        if (data) {
          const newData: TClassificationForm = {
            ...data,
            listClassification: {
              id: data.listClassification.id,
              name: data.listClassification.name,
              code: Number(data.listClassification.code),
            },
          };
          return { data: newData, success: true };
        }
        return { data, success };
      },
      [get]
    );
    const successHandle = () => {
      onBackButton();
    };

    const loading = sLoading || uLoading || gLoading;

    return (
      <FormContainer<TClassificationForm>
        saveFunction={saveHandler}
        updateFunction={updateHandler}
        getFunction={getHandler}
        loading={loading}
        title={t(translationPath + "title")}
        schema={classificationSchema}
        subtitle={t(translationPath + "new")}
        backButtonOnClick={onBackButton}
        redirectOnSave={false}
        onSuccess={successHandle}
        isModalForm={true}
        propId={id}
        formActionsOnBottom={false}
        fields={() => (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <AutoComplete
                getOptionLabel={({ name }) => name}
                size="small"
                label={t(translationPath + "list_classification")}
                name="listClassification"
                request={listClassificationsByProfileAccess}
              />
            </Grid>
          </Grid>
        )}
      />
    );
  }
);
